/**
 * 単位と物理定数。内部計算と保存データは SI 単位（m, kg, s, rad）で統一し、
 * 表示・入力のときだけここの関数で変換する（ADR-0011）。
 */

/** 標準重力加速度 g₀ [m/s²]。G の正規化に使い、環境の重力設定によらず一定。 */
export const STANDARD_GRAVITY = 9.80665;

/** 度 → ラジアン */
export function degToRad(degrees: number): number {
  return (degrees * Math.PI) / 180;
}

/** ラジアン → 度 */
export function radToDeg(radians: number): number {
  return (radians * 180) / Math.PI;
}

/** m/s → km/h */
export function mpsToKmh(metersPerSecond: number): number {
  return metersPerSecond * 3.6;
}

/** km/h → m/s */
export function kmhToMps(kilometersPerHour: number): number {
  return kilometersPerHour / 3.6;
}

/** m → ft */
export function metersToFeet(meters: number): number {
  return meters / 0.3048;
}

/** ft → m */
export function feetToMeters(feet: number): number {
  return feet * 0.3048;
}

/** 加速度 [m/s²] → G（標準重力加速度で正規化） */
export function accelerationToG(metersPerSecondSquared: number): number {
  return metersPerSecondSquared / STANDARD_GRAVITY;
}
